'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { takeHandedOverPageChat } from '@/lib/chat/page-chat-handoff';
import { useChatStore } from '@/lib/stores/chat-store';
import { cleanupPrStoreContext, initializePrStoreContext } from '@/lib/stores/pr-store';
type PrV2ClientStoreProps = {
  owner: string;
  repo: string;
  number: string;
  installationId: number | null;
  repositoryId: number | null;
  pullRequestId: string;
};
export function PrV2ClientStore(t0) {
  const $ = _c(9);
  const {
    owner,
    repo,
    number,
    installationId,
    repositoryId,
    pullRequestId
  } = t0;
  const ensureChatScope = useChatStore(_temp);
  let t1;
  let t2;
  if ($[0] !== ensureChatScope || $[1] !== installationId || $[2] !== number || $[3] !== owner || $[4] !== pullRequestId || $[5] !== repo || $[6] !== repositoryId) {
    t1 = () => {
      initializePrStoreContext({
        owner,
        repo,
        number,
        installationId,
        repositoryId,
        pullRequestId
      });
      ensureChatScope(pullRequestId, () => takeHandedOverPageChat(pullRequestId));
      return () => {
        ensureChatScope(null);
        cleanupPrStoreContext({
          owner,
          repo,
          number
        });
      };
    };
    t2 = [ensureChatScope, installationId, number, owner, pullRequestId, repo, repositoryId];
    $[0] = ensureChatScope;
    $[1] = installationId;
    $[2] = number;
    $[3] = owner;
    $[4] = pullRequestId;
    $[5] = repo;
    $[6] = repositoryId;
    $[7] = t1;
    $[8] = t2;
  } else {
    t1 = $[7];
    t2 = $[8];
  }
  useEffect(t1, t2);
  return null;
}
function _temp(state) {
  return state.ensureChatScope;
}